import useHttpProvider from "@/common/hooks/use-http";
import { useIsMobile } from "@/common/hooks/use-mobile";
import { useEffect, useMemo, useState } from "react";
import { Promotion } from "../models/giveaway";
import * as GiveawaysService from "../services/giveaways";

export const FILTERS = [
	{ label: "All Giveaways", value: "all" },
	{ label: "Monthly", value: "monthly" },
	{ label: "Weekly", value: "weekly" },
];

export function useUpcomingPrizes() {
	const isMobile = useIsMobile();
	const { http } = useHttpProvider();

	const [selectedFilter, setSelectedFilter] = useState("all");
	const [visibleCount, setVisibleCount] = useState(4);
	const [upcomingPrizes, setUpcomingPrizes] = useState<Promotion[]>([]);

	useEffect(() => {
		const fetchPromotions = async () => {
			const response = await GiveawaysService.getUpcomingPromotions(http);
			setUpcomingPrizes(response);
		};
		fetchPromotions();
	}, [http]);

	const filteredPrizes = useMemo(() => {
		if (selectedFilter === "all") return upcomingPrizes;
		return upcomingPrizes.filter(
			(prize) => prize.type.toString() === selectedFilter
		);
	}, [upcomingPrizes, selectedFilter]);

	const visiblePrizes = useMemo(() => {
		return isMobile ? filteredPrizes.slice(0, visibleCount) : filteredPrizes;
	}, [filteredPrizes, isMobile, visibleCount]);

	const handleLoadMore = () => setVisibleCount((prev) => prev + 4);

	return {
		isMobile,
		selectedFilter,
		setSelectedFilter,
		visibleCount,
		setVisibleCount,
		upcomingPrizes,
		filteredPrizes,
		visiblePrizes,
		handleLoadMore,
	};
}
